module.exports = __webpack_public_path__ + "static/Cubby-1d88edbc8351dcf102f69a92dd6160ac.jpeg";